/**
 * i18n bootstrap. Loads EN + FR resources and wires up
 * i18next with localStorage persistence. Language toggle
 * lives in Navbar; changes here propagate to every
 * useTranslation() call via context.
 *
 * We deliberately DON'T use i18next-browser-languagedetector's
 * auto-detect on first visit — HepCURE serves both anglophones
 * and francophones and product wants English as the default
 * baseline. The toggle is the only trigger.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import fr from "./locales/fr.json";

const STORAGE_KEY = "hepcure.lang";

const savedLang = (() => {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v === "fr" || v === "en" ? v : "en";
  } catch {
    return "en";
  }
})();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    lng: savedLang,
    fallbackLng: "en",
    interpolation: { escapeValue: false }, // React already escapes
    returnEmptyString: false,
  });

// Keep <html lang> in sync so screen readers + browser translate
// tools see the right locale, and so CSS `:lang(fr)` selectors work.
const applyHtmlLang = (lng) => {
  try { document.documentElement.setAttribute("lang", lng); } catch { /* ssr */ }
};
applyHtmlLang(savedLang);
i18n.on("languageChanged", (lng) => {
  applyHtmlLang(lng);
  try { window.localStorage.setItem(STORAGE_KEY, lng); } catch { /* private mode */ }
});

export default i18n;
